<vc-catalog
  [page]="page"
  [config]="configCatalog"
  [breadcrumb]="breadcrumb"
  [searchParameters]="searchParameters"
  [likedItem]="likedItem"
  [facetLink]="facetLink"
  [isFirstPage]="isFirstPage"
  [searchStore]="searchStore"
  [currentCountry]="currentCountry"
  [campaign]="campaign"
  [seoLinks]="seoLinks"
  [seoContents]="seoContents"
>
</vc-catalog>
